import React, { useEffect, useState, useRef } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// config file

const Invoices = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);

  let user = localStorage.getItem('loginCredentials') ? JSON.parse(localStorage.getItem('loginCredentials')) : {};
  let dataTableRef = useRef(null);
  const params = useParams();
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions("Invoices");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    const categoryTypes = [
      { label: "Debit Invoice", value: "Debit Invoice", color: "danger" },
      { label: "Sales Invoice", value: "Sales Invoice", color: "success" },
      { label: "Credit Invoice", value: "Credit Invoice", color: "info" },
      { label: "Proforma Invoice", value: "Proforma Invoice", color: "primary" },
      { label: "Return Invoice", value: "Return Invoice", color: "warning" },
      { label: "Others", value: "Others", color: "secondary" },
    ];

    let data = [
      {
        textAlign: "center",
        width: "5%",
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: false,
        mobile: true,
        displayInSettings: true,
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        tDisplay: true,
      },
      {
        textAlign: "center",
        width: "5%",
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        show: true,
        textAlign: "center",
        width: "10%",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
      {
        name: "fileName",
        type: "text",
        placeholder: "File",
        label: "File",
        header: "File",
        width: "15%",
        id: "fileName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "redirectable",
        fileViewType: 'view',
        textAlign: "left",
        globalSearchField: "true",
        show: true,
        field: "fileName",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
        displayIcon: true,
        fieldTypes: 'fileUpload',
        filter: true,
        redirectFilterField: 'parentFolderId',
        redirecTo: 'myDocuments',
        // iconName : 'folder',
        showIcon: true,
      },
      {
        name: "complianceStatus",
        type: "dropDown",
        placeholder: "Compliance Status",
        label: "Compliance Status",
        header: "Compliance Status",
        field: "complianceStatus",
        options: [
          { label: "passed", value: "passed", color: "success" },
          { label: "failed", value: "failed", color: "danger" },
        ],
        width: "10%",
        textAlign: "center",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        tDisplay: true,
        sortable: true,
        filter: true,
        style: {
          textTransform: 'uppercase'
        }
      },
      {
        name: "invoiceNumber",
        type: "text",
        placeholder: "Invoice Number",
        label: "Invoice Number",
        width: "10%",
        header: "Invoice Number",
        field: "invoiceNumber",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "invoiceDate",
        type: "date",
        placeholder: "Invoice Date",
        label: "Invoice Date",
        width: "10%",
        header: "Invoice Date",
        field: "invoiceDate",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "billerName",
        type: "text",
        placeholder: "Biller Name",
        label: "Biller Name",
        width: "15%",
        header: "Biller Name",
        field: "billerName",
        sortable: true,
        filter: true,
        show: true,
        mobile: false,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "buyerName",
        type: "text",
        placeholder: "Buyer Name",
        label: "Buyer Name",
        width: "15%",
        header: "Buyer Name",
        field: "buyerName",
        sortable: true,
        filter: true,
        show: true,
        mobile: false,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "category",
        type: "dropDown",
        placeholder: "Category",
        label: "Category",
        header: "Category",
        field: "category",
        options: categoryTypes,
        width: "10%",
        textAlign: "center",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        tDisplay: true,
        sortable: true,
        filter: true,
        mobile: false,
        style: {
          textTransform: 'uppercase'
        }
      },
      {
        name: "currency",
        type: "text",
        placeholder: "Currency",
        label: "Currency",
        width: "5%",
        header: "Currency",
        field: "currency",
        fieldType: "text",
        sortable: true,
        filter: true,
        show: true,
        mobile: false,
        displayInSettings: true,
        tDisplay: true,
        textAlign: "center",
        style: {
          fontWeight: 700,
          color: "#12225f"
        }
      },
      {
        name: "subtotal",
        type: "text",
        placeholder: "Subtotal",
        label: "Subtotal",
        width: "10%",
        header: "Subtotal",
        field: "subtotal",
        sortable: true,
        filter: true,
        textAlign: "Right",
        show: true,
        mobile: false,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "taxAmount",
        type: "text",
        placeholder: "Tax Amount",
        label: "Tax Amount",
        width: "10%",
        header: "Tax Amount",
        field: "taxAmount",
        sortable: true,
        filter: true,
        textAlign: "Right",
        show: true,
        mobile: false,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "totalAmount",
        type: "text",
        placeholder: "Total Amount",
        label: "Total Amount",
        width: "10%",
        header: "Total Amount",
        field: "totalAmount",
        sortable: true,
        filter: true,
        textAlign: "Right",
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "createdByName",
        type: "text",
        placeholder: "Created By",
        label: "Created By",
        width: "10%",
        header: "Created By",
        field: "createdByName",
        sortable: true,
        filter: true,
        show: false,
        mobile: false,
        displayInSettings: true,
        tDisplay: true,
      },


    ];

    return data;
  };


  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "name",
        fieldName: "name",
        type: "text",
        placeholder: "Name",
        value: "",
        label: "Name",
        width: "120px",
        addFormOrder: 1,
        editFormOrder: 1,
        stringType: null,
        derivedValue: "name=undefined",
        capitalizeTableText: false,
        sortable: true,
        filter: true,
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: "",
        globalSearchField: "true",
        controllerId: null,
        isClickable: "",
        isAddToIndex: false,
        isBulkUploadField: true,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
        capitalizeValue: true
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
    console.log("Submit Button in sode          ");
  };

  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    // window.location.reload();
    if (dataTableRef.current) {
      const { getDataFromServer, filterCriteria } = await dataTableRef.current;
      getDataFromServer(filterCriteria);
    }
  };

  const saveDataToServer = async (item, field, value) => {
    let userBody;
    if (item?.length > 0 && field && value) {
      let selectedIds = item.map((row) => row._id);
      userBody = {
        selectedIds: selectedIds,
        updatedDetails: { [field]: value },
      };
    } else {
      return;
    }
    if (userBody) {
      let method, apiUrl;
      method = "POST";
      apiUrl = `${apiCalls.agreement}/multiUpdate`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  const isEditPermission = rolePermission?.type == "Edit" ? true : false;
  const actionTypes = [
    {
      name: "Delete",
      options: [
        {
          label: "Delete",
          value: "Delete",
          show: rolePermission?.actions?.includes("Delete") ? true : false,
          multiple: true,
        },
      ],
    },
  ];
  // const rowExpansionTemplate = (rowData) => {
  //   return (
  //     <div className="expansion-content">
  //       <AudioPlayer rowData={rowData} />
  //     </div>
  //   );
  // };

  const files = [
    "invoice.zip"
  ];

  const sampleFiles = files.map(fileName => ({
    filePath: `${config.imgUrl}server/upload/aiPocSampleFiles/${fileName}`,
    fileName
  }));
  const complianceViewModalTemplate = (data) => {
    if (!data) return null;

    const formatCurrency = (amount) => {
      if (!amount) return "N/A";
      return `${data?.currency} ${parseFloat(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    };

    const getSeverityBadge = (severity) => {
      let className = "";
      switch (severity?.toLowerCase()) {
        case "high": className = "bg-danger"; break;
        case "medium": className = "bg-warning"; break;
        case "low": className = "bg-info"; break;
        default: className = "bg-secondary";
      }
      return <span className={`badge ${className} text-white px-1 py-0`} style={{ fontSize: '11px' }}>{severity}</span>;
    };

    return (<>
      {/* Invoice Summary Cards */}
      <div className="row mb-3" style={{ fontSize: '12px', fontWeight: 'normal' }}>
        <div className="col-md-6 mb-2">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-header py-1" style={{ backgroundColor: 'white' }}>
              <h6 className="card-title mb-0 fw-bold" style={{ fontSize: '14px' }}>Invoice Information</h6>
            </div>
            <div className="card-body py-2" style={{ backgroundColor: 'white', fontWeight: 'normal' }}>
              <div className="row">
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Biller</small>
                  <div>{data?.billerName}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Buyer</small>
                  <div>{data?.buyerName}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Invoice Date</small>
                  <div>{data?.invoiceDate}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Currency</small>
                  <div>{data?.currency}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Document Type</small>
                  <div>{data?.type?.toUpperCase()}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Review Needed</small>
                  <div>
                    <span className={`badge ${data?.reviewNeeded === "true" ? "bg-warning" : "bg-success"} text-white px-1 py-0`} style={{ fontSize: '11px' }}>
                      {data?.reviewNeeded === "true" ? "Yes" : "No"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-2">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-header py-1" style={{ backgroundColor: 'white' }}>
              <h6 className="card-title mb-0 fw-bold" style={{ fontSize: '14px' }}>Financial Summary</h6>
            </div>
            <div className="card-body py-2" style={{ backgroundColor: 'white', fontWeight: 'normal' }}>
              <div className="row">
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Subtotal</small>
                  <div className="text-primary">{data?.currency + " " + data?.subtotal}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Tax Amount</small>
                  <div>{formatCurrency(data?.taxAmount)}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Other Charges</small>
                  <div>{data?.otherCharges ? formatCurrency(data?.otherCharges) : "N/A"}</div>
                </div>
                <div className="col-6 mb-1">
                  <small className="text-muted d-block">Total Amount</small>
                  <div className="text-success" style={{ fontSize: '13px' }}>{data?.currency + " " + data?.totalAmount}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Line Items */}
      <div className="card border-0 shadow-sm mb-3" style={{ fontSize: '12px', backgroundColor: 'white', fontWeight: 'normal' }}>
        <div className="card-header py-1 d-flex justify-content-between align-items-center" style={{ backgroundColor: 'white' }}>
          <h6 className="card-title mb-0 fw-bold" style={{ fontSize: '14px' }}>Line Items</h6>
          <span className="badge bg-secondary px-1 py-0" style={{ fontSize: '11px' }}>{data?.lineItems?.length} items</span>
        </div>
        <div className="card-body p-0" style={{ backgroundColor: 'white' }}>
          <div className="table-responsive">
            <table className="table table-hover mb-0" style={{ fontSize: '12px' }}>
              <thead>
                <tr>
                  <th className="border-0 py-1 fw-bold">Description</th>
                  <th className="border-0 py-1 text-center fw-bold">Quantity</th>
                  <th className="border-0 py-1 text-end fw-bold">Unit Price</th>
                  <th className="border-0 py-1 text-end fw-bold">Line Total</th>
                </tr>
              </thead>
              <tbody>
                {data?.lineItems.map((item, idx) => (
                  <tr key={idx}>
                    <td className="py-1">{item?.description}</td>
                    <td className="py-1 text-center">{item?.quantity}</td>
                    <td className="py-1 text-end">{(item?.unitPrice)}</td>
                    <td className="py-1 text-end fw-bold">{(item?.lineTotal)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Compliance Issues */}
      {data?.complianceIssues && data?.complianceIssues.length > 0 && (
        <div className="card border-0 shadow-sm mb-3" style={{ fontSize: '12px', backgroundColor: 'white', fontWeight: 'normal' }}>
          <div className="card-header py-1 d-flex justify-content-between align-items-center" style={{ backgroundColor: 'white' }}>
            <h6 className="card-title mb-0 fw-bold" style={{ fontSize: '14px' }}>Compliance Issues</h6>
            <span className="badge bg-danger px-1 py-0" style={{ fontSize: '11px' }}>{data?.complianceIssues.length} issues</span>
          </div>
          <div className="card-body p-0" style={{ backgroundColor: 'white' }}>
            <div className="table-responsive">
              <table className="table table-hover mb-0" style={{ fontSize: '12px' }}>
                <thead>
                  <tr>
                    <th className="border-0 py-1 fw-bold">Field</th>
                    <th className="border-0 py-1 fw-bold">Issue</th>
                    <th className="border-0 py-1 fw-bold">Severity</th>
                    <th className="border-0 py-1 fw-bold">Current Value</th>
                    <th className="border-0 py-1 fw-bold">Expected</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.complianceIssues.map((issue, idx) => (
                    <tr key={idx} className={issue.severity === "high" ? "table-danger" : issue.severity === "medium" ? "table-warning" : ""}>
                      <td className="py-1 fw-bold">{issue.field}</td>
                      <td className="py-1">{issue.issue}</td>
                      <td className="py-1">{getSeverityBadge(issue.severity)}</td>
                      <td className="py-1">
                        <small>{issue.currentValue}</small>
                      </td>
                      <td className="py-1">{issue.expected || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Additional calculations table for tax issues */}
            {data?.complianceIssues.some(issue => issue.calculatedFromSubtotal) && (
              <div className="p-2 border-top" style={{ fontSize: '12px' }}>
                <h6 className="mb-2 fw-bold" style={{ fontSize: '13px' }}>Calculated Values</h6>
                <div className="table-responsive">
                  <table className="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="py-1 fw-bold">Field</th>
                        <th className="py-1 fw-bold">Calculated From Subtotal</th>
                        <th className="py-1 fw-bold">Expected Total</th>
                        <th className="py-1 fw-bold">Calculated Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.complianceIssues
                        .filter(issue => issue.calculatedFromSubtotal)
                        .map((issue, idx) => (
                          <tr key={idx}>
                            <td className="py-1">{issue.field}</td>
                            <td className="py-1">{issue.calculatedFromSubtotal || "-"}</td>
                            <td className="py-1">{issue.expectedTotal || "-"}</td>
                            <td className="py-1">{issue.calculatedTotal || "-"}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Document Information */}
      <div className="card border-0 shadow-sm mb-3" style={{ fontSize: '12px', backgroundColor: 'white', fontWeight: 'normal' }}>
        <div className="card-body py-2" style={{ backgroundColor: 'white' }}>
          <div className="row">
            <div className="col-md-6 mb-1">
              <small className="text-muted d-block">File Name</small>
              <div>{data?.fileName}</div>
            </div>
            <div className="col-md-6 mb-1">
              <small className="text-muted d-block">Created By</small>
              <div>{data?.createdByName}</div>
            </div>
            <div className="col-md-6 mb-1">
              <small className="text-muted d-block">Document ID</small>
              <small className="text-muted font-monospace">{data?._id}</small>
            </div>
            <div className="col-md-6 mb-1">
              <small className="text-muted d-block">Status</small>
              <span className={`badge ${data?.active ? "bg-success" : "bg-secondary"} px-1 py-0`} style={{ fontSize: '11px' }}>
                {data?.active ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>)
  }
  const checkDataToRefresh = (data = []) => {
    return data.some(item => item.complianceStatus === "processing");
  };

  return (
    <span>
      {
        <DataTables
          onRef={(ref) => (dataTableRef.current = ref)}
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          addRequired={false}
          editRequired={false}
          deleteRequired={true}
          viewRequired={true}
          exportRequired={true}
          sample={false}
          printRequried={false}
          actionsTypes={false}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath.agreement}
          displayName="Invoices"
          type="invoice"
          routeTo={apiCalls.invoice}
          displayViewOfForm="modal"
          sideFormLeftOrRight="right"
          apiResponseKey={apiCalls.invoice?.toLowerCase()}
          apiUrl={apiCalls.invoice}
          selectedId={params.id}
          displayActionsInTable={"actions"}
          filterClearRequired={true}
          hideActions={true}
          sampleFiles={sampleFiles}
          viewModalTemplate={complianceViewModalTemplate}
          customUpload={true}

        />
      }

    </span>
  );
};

export default Invoices;
